export function branchEditKey(id) {
  const baseKey = ['top_base', 'chpp', 'private_point'].find(key => id[key] != null)
  return `branch_${baseKey}_${id[baseKey]}_${id.brId}`
}
